import { INSTITUTION_STATUS_LIST } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

const reducer = hOReducer(INSTITUTION_STATUS_LIST, {
  statusList: [],
  studyTypeList: [],
  memberRoleList: []
});
export default reducer;
